/**
 * Created by Bart Decorte
 * Date: 14/09/2021
 * Time: 14:53
 */
import UploadPreview from './UploadPreview';

export default class UploadPreviewSingle extends UploadPreview {
  constructor(rootEl, params = {}) {
    super(rootEl, params);
    if (this.hasClearButton()) {
      this.setClearButtonState(true);
    }
    this.showProgress(true);
  }

  setState(state = '') {
    this.progressEl().className = `dz-progress dz-progress-${state} js-progress`;
  }

  setProgress(progress) {
    this.progressEl().style.width = this.progressWidth(progress) + '%';
  }

  showProgress(doShow) {
    this.progressEl().style.display = doShow ? 'block' : 'none';
    return this;
  }

  resetProgress() {
    this.showProgress(false);
    this.setProgress(0)
    this.setState();
  }

  cancel() {
    if (this.hasClearButton()) {
      this.setClearButtonState(false);
    }
    this.resetProgress();
    super.cancel();
  }

  hasStoredData() {
    return false;
  }

  hasClearButton() {
    return !!this.btnClearEl();
  }

  setClearButtonState(state) {
    if (state && this.btnClearEl().classList.contains('disabled')) {
      this.btnClearEl().classList.remove('disabled');
    } else if (!state && !this.btnClearEl().classList.contains('disabled')) {
      this.btnClearEl().classList.add('disabled');
    }
  }

  progressEl() {
    return this.rootEl.querySelector('.js-progress');
  }

  btnClearEl() {
    return this.rootEl.querySelector('.js-btn-clear');
  }

  btnDeleteEl() {
    return this.rootEl.querySelector('.js-btn-delete');
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/uploads/UploadPreviewSingle.js